; (function (jQuery) {

    "use strict";

    function Main() {
        var fn = {
            init: function () {
                jQuery('.no-js').removeClass('no-js');
                fn.loadSessionContextual();

                jQuery('main').fitVids({
                    customSelector: 'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
                });

                jQuery('.js-post-select').on('change', fn.applyPostFilter);
                jQuery('.text-field.has-error').find('input, select, textarea').each(fn.initValidationListeners);
                jQuery('.js-select2').each(fn.initSelect2);
                jQuery('.js-file-field__input').on('change', fn.handleFileInputChange);
                jQuery('.js-remove-profile-image').on('click', fn.handleRemoveProfileImage);
            },

            handleRemoveProfileImage: function() {
                jQuery.ajax({
                    url: baatajax.rest_endpoint + 'baat/v1/remove-profile-image/',
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('X-WP-Nounce', baatajax.rest_nonce)
                    },
                    method: 'POST',
                    success: function() {
                        window.location.href = window.location.href;
                    }
                });
            },

            handleFileInputChange: function (e) {
                var fileInput = jQuery(e.currentTarget);
                var fileName = fileInput.val()
                    .replace(/\\/g, '/')
                    .replace(/.*\//, '');

                fileInput.closest('.file-field')
                    .find('.file-field__filename')
                    .text(fileName);
            },

            initSelect2: function (i, elem) {
                const placeholder = jQuery(elem).data('placeholder');
                jQuery(elem).select2({ placeholder });
            },

            applyPostFilter: function()
            {
                var slug = jQuery(this).val();
                var href = window.location.href;
                var filterName = jQuery(this).data('filter-name');

                if (href.indexOf('?') !== -1)
                {
                    href = href.substring(0, href.indexOf('?'));
                }

                if (slug)
                {
                    href = `${href}?${filterName}=${slug}`;
                }

                window.location = href;
            },

            /**
			 * Because pages are cached, some user-specific details needs to be AJAXed in.
             *
             * Usually we'd need to send a nonce for rest API calls,
             * but we've overridden that as we need this to work with caching
			 */
			loadSessionContextual: function()
			{
				jQuery.post(jQuery('.site-header__contextual[data-endpoint]').attr('data-endpoint'))
                    .done(fn.handleSessionContextual)
                    .fail(function() {
                        if (typeof console.warn != 'undefined')
                            console.warn('Session Contextual call failed');
				    });
			},

            handleSessionContextual: function(data)
            {
                if (data.status)
				{
					jQuery('.site-header__contextual--desktop').html(data.payload.headerFragmentDesktop)
					jQuery('.site-header__contextual--mobile').html(data.payload.headerFragmentMobile)
				}
            },

            /**
             * Most of the validation happens server-side,
             * but lets hide the outlines on change
             */
            initValidationListeners: function(i, elem)
            {
                var jElem = jQuery(elem);
                jElem.attr('data-original', jElem.val());
                jElem.on('focusout', function() {
                    var inputElem = jQuery(this);
                    if (inputElem.attr('data-original') !== inputElem.val()) {
                        inputElem.parents('.has-error').removeClass('has-error');
                    }
                });
            }
        }

        jQuery(fn.init);
    }

    new Main();
})(jQuery);